import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Components
import Button from '../../atoms/Button';
import Content from '../../atoms/Content';

// Constants
import { SINGULAR_LABEL, PLURAL_LABEL } from './selectionSummary.constants';
import { shouldShowSingularLabel } from './selectionSummary.helpers';

// Styles
import s from './selectionSummary.module.scss';
var SelectionSummary = function SelectionSummary(props) {
  var selectionCount = props.selectionCount,
    onClick = props.onClick,
    className = props.className,
    selectionLabel = props.selectionLabel;
  var selectionLabelText = shouldShowSingularLabel(selectionCount) ? selectionLabel.singular : selectionLabel.plural;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex-center ".concat(className)
  }, /*#__PURE__*/React.createElement(Content, {
    className: s.selectionCount
  }, selectionCount), /*#__PURE__*/React.createElement(Content, null, selectionLabelText), /*#__PURE__*/React.createElement(Button, {
    view: Button.VIEW.TERTIARY,
    onClick: onClick,
    className: "m-l-8"
  }, __('Clear')));
};
SelectionSummary.propTypes = {
  selectionCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  selectionLabel: PropTypes.shape({
    singular: PropTypes.string,
    plural: PropTypes.string
  })
};
SelectionSummary.defaultProps = {
  onClick: _noop,
  className: '',
  selectionLabel: {
    singular: SINGULAR_LABEL,
    plural: PLURAL_LABEL
  }
};
export default SelectionSummary;